export default String.raw`
.newsletter {
    padding: 24px 5%;
    min-height: none;

    &__container {
        grid-template-rows: min-content auto auto;
        grid-template-columns: 100%;
        grid-template-areas: "h"
                            "c"
                            "f";
        row-gap: 16px;

        &-title {
            svg {
                display: none;
            }

            div {
                p {
                    display: none;
                }
            }
        }

        &-content {
            &-icons {
                grid-template-columns: 100%;
                row-gap: 16px;
            }
        }

        &-form {
            padding: 0;

            &-info {
                display: block;
            }

            p {
                order: 1;

                &:first-child {
                    width: 100%;
                    order: 1;
                }
            }

            div {
                order: 1;

                &:first-child {
                    order: 1;
                    width: 100%;
                }
            }

            button {
                min-width: 100%;
                max-width: 100%;
            }
        }
    }
}
`